import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import TwoFactorAuthModal from '../components/TwoFactorAuthModal';
import { FiShield, FiCreditCard, FiUser } from 'react-icons/fi';

const Account = () => {
  const { user, fetchUser } = useContext(AuthContext);
  const [securityOpen, setSecurityOpen] = useState(false);
  const navigate = useNavigate();

  if (!user) return null;

  const accessLabel = user.private_beta_access
    ? 'Private Beta'
    : user.scanner_access
      ? 'Scanner Active'
      : user.methodology_access
        ? 'Framework Only'
        : 'No Active Product';

  return (
    <div className="workspace-page" style={{maxWidth:'900px', margin:'0 auto'}}>
      <div className="page-header">
        <div className="page-header-copy">
          <div className="eyebrow">Account</div>
          <h1 className="page-title">Ο λογαριασμός σου</h1>
          <p className="page-description">Πρόσβαση, ασφάλεια και billing σε ένα σημείο.</p>
        </div>
      </div>

      <div className="ws-grid two">
        <section className="ws-panel pad">
          <div className="section-header"><h2 className="section-title"><FiUser/> Profile</h2></div>
          <div className="component-list">
            <div className="component-row"><span>Username</span><strong>{user.username}</strong></div>
            <div className="component-row"><span>Email</span><strong>{user.email}</strong></div>
            <div className="component-row"><span>Access</span><strong>{accessLabel}</strong></div>
          </div>
        </section>

        <section className="ws-panel pad">
          <div className="section-header"><h2 className="section-title"><FiShield/> Security</h2></div>
          <p className="page-subtitle">Two-factor authentication: <strong>{user.is_two_factor_enabled ? 'ON' : 'OFF'}</strong></p>
          <button className="ws-button primary" onClick={() => setSecurityOpen(true)}>
            <FiShield/> {user.is_two_factor_enabled ? 'Manage 2FA' : 'Enable 2FA'}
          </button>
        </section>
      </div>

      <section className="ws-panel pad" style={{marginTop:'1rem'}}>
        <div className="section-header"><h2 className="section-title"><FiCreditCard/> Plan & Billing</h2></div>
        <p className="page-subtitle">Δες το package ownership, το Scanner subscription status, invoices και payment method.</p>
        <button className="ws-button" onClick={() => navigate('/billing')}><FiCreditCard/> Open Plan & Billing</button>
      </section>

      <TwoFactorAuthModal
        isOpen={securityOpen}
        onClose={() => setSecurityOpen(false)}
        onComplete={async () => { await fetchUser(); setSecurityOpen(false); }}
      />
    </div>
  );
};

export default Account;
